import type { AxiosInstance } from 'axios'

export const getCompanyStatistics = (api: AxiosInstance) => () =>
  api.get('/v1.0/admin/companies/statistics')
